import themeSliceReducer from './slice';

export const themeReducer = themeSliceReducer;
